/* eslint-disable react-hooks/exhaustive-deps */
import {
  Card,
  Col,
  Collapse,
  Divider,
  Dropdown,
  Progress,
  Row,
  Space,
  Table,
  Typography,
  theme,
  Tooltip
} from "antd";
import React, { useEffect, useState } from "react";
import { MdInfoOutline } from "react-icons/md";
import { PiCaretDownLight } from "react-icons/pi";
import { useSearchParams } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import caution from "../../../assets/img/caution.png";
import RedDot from "../../../assets/img/red-dot.svg";
import {
  fetchSKUCompareDetails,
  resetShowCollapsed,
  updateCollapsed,
} from "../../../redux/reducer/compareTableSlice";

const deletionCss = {
  color: "rgb(0, 0, 0)",
  border: "1px solid #ec6157",
  background: "#FFF7F6",
  borderLeft: "4px solid #ec6157",
  borderRadius: "0px 4px 4px 0px",
  width: "max-content"
}

const cautionCss = {
  color: "rgb(0, 0, 0)",
  border: "1px solid #ecad27",
  background: "rgb(255, 253, 242)",
  borderLeft: "4px solid #ecad27",
  borderRadius: "0px 4px 4px 0px",
  width: "max-content"
}

const { Text } = Typography;

function SUDetailCard({ data, target }) {
  const {
    token: { colorPrimary, colorUnilever },
  } = theme.useToken();
  const dispatch = useDispatch();

  const { showCollpased } = useSelector((state) => state.compareTable);

  const [selectedSku, setSelectedSku] = useState();
  const [searchParams] = useSearchParams();
  const isRegionalView =
    searchParams.get("distributionCenter") === "null" ? false : true;
  const items = data.sku?.map((item) => {
    let key = Object.keys(item)[0];
    let value = Object.values(item)[0];
    return { key: key, label: value };
  });

  useEffect(() => {
    setSelectedSku(items[0]);

    return () => {
      dispatch(resetShowCollapsed());
    };
  }, []);

  const categoryUtilizationColumns = [
    {
      title: "Sub Family",
      dataIndex: "subfamily",
      key: "subfamily",
    },
    {
      title: "Line",
      dataIndex: "line",
      key: "line",
    },
    {
      title: "Utilization %",
      dataIndex: "utilization",
      key: "utilization",
    },
  ];

  const handleSkuSelect = (e) => {
    const payload = {
      tarketSKU: searchParams.get("tarketSKUCode"),
      targetPlant: searchParams.get("tarketPlantCode"),
      brandCode: searchParams.get("brandCode"),
      alternativeSKU:
        e.key === 'A00000000000000000' ? data.allSKU : [items.find((item) => item['key'] === e.key)?.key] || [selectedSku.key],
      // items.find((item) => item['key'] === e.key)
      //   ? data.sku?.map((item) => Object.keys(item)[0])
      //   : [selectedSku.key],
      alternativePlantCode: data?.plantCode,
      type: searchParams.get("type"),
    };
    dispatch(fetchSKUCompareDetails(payload));

    setSelectedSku(items.filter((item) => item.key === e.key)[0]);
  };
  const MarkedForDeletion = () => {
    return <Tooltip placement="right" overlayInnerStyle={deletionCss} arrow={false} title="Marked for Deletion" key="#f5d692">
      <img
        src={RedDot}
        alt="RedDot"
        style={{ marginBottom: 2, marginLeft: 4, height: 12 }}
      />
    </Tooltip>
  }

  const CautionFlag = () => {
    return <Tooltip placement="right" overlayInnerStyle={cautionCss} arrow={false} title="Caution: Some components are marked for deletion" key="#f5d692">
      <img
        src={caution}
        alt="caution"
        style={{ marginBottom: 2, marginLeft: 4, height: 16 }}
      />
    </Tooltip>
  }

  return (
    <Card bordered className="su-details-card">
      <div
        style={{
          padding: 8,
          textAlign: "center",
          backgroundColor: "#EBF3FF",
          borderBottom: "1px solid #f0f0f0",
        }}>
        <Text strong style={{ fontSize: 14 }}>
          Plant: {data?.plantName}
        </Text>
        <br />
        <Text style={{ fontSize: 11 }}>
          {data?.country} | {data?.city}
        </Text>
        <br />
        <Text>{data?.Dimension}</Text>

        <Row align="middle" style={{ padding: "8px 0" }}>
          <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
            <Space>
              <Text>Match Avg</Text>
              <div style={{ marginTop: 4 }}>
                <Progress
                  type="circle"
                  strokeColor={colorPrimary}
                  percent={data.PLMMatchPercentage}
                  size={16}
                  strokeWidth={24}
                />
              </div>

              <Text strong>{data.PLMMatchPercentage}%</Text>
            </Space>
          </Col>
          {searchParams.get("tarketPlantCode") === data?.plantCode ? (
            <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
              <Space align="center" style={{ gap: 4 }}>
                <MdInfoOutline
                  size={16}
                  color={colorUnilever}
                  style={{ marginBottom: -4 }}
                />
                <Text>Current Sourcing Unit</Text>
              </Space>
            </Col>
          ) : null}
        </Row>
      </div>

      <Dropdown
        menu={{
          items,
          onClick: handleSkuSelect,
        }}
        trigger={["click"]}
        placement="bottom"
        dropdownRender={(menu) => (
          <div style={{ height: 200, overflow: "auto" }}>
            {React.cloneElement(menu)}
          </div>
        )}>
        <Space
          align="center"
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "8px 16px 0 16px ",
          }}>
          <Text strong style={{ color: colorPrimary }}>
            {selectedSku?.label}
          </Text>
          <PiCaretDownLight size={12} color={colorPrimary} />
        </Space>
      </Dropdown>
      <Divider style={{ margin: "8px 0" }} />

      <div style={{ padding: "0 16px 16px 16px" }}>
        <Row align="middle">
          <Col span={12}>
            <Text strong>Pack Size</Text>
          </Col>
          <Col span={12}>
            <Text>{data?.Dimension}</Text>
          </Col>
        </Row>
        <Divider style={{ margin: "8px 0" }} />

        <Row>
          <Col span={12}>
            <Text strong>Raw Materials</Text>
          </Col>
          <Col span={12}>
            <Text title="what percentage of the raw materials in the BOM of the target SKU are present at this factory/sku.">
              {Math.round(
                (data.rawMaterial.totalMatch / target.targetRMCount) * 100
              )}
              %
            </Text>
          </Col>
          <Col span={24}>
            <Collapse
              size="small"
              bordered={false}
              ghost
              activeKey={showCollpased.rm}
              onChange={(key) => {
                dispatch(updateCollapsed({ rm: key }));
              }}
              items={[
                {
                  key: "1",
                  label: <>
                    Match ({data.rawMaterial.totalMatch})
                    {data.rawMaterial.matchIndicator?.map(obj => obj.ComponentDeletionIndicator).includes("X") ? <CautionFlag /> : null}
                  </>,
                  children: (
                    <ul
                      style={{
                        maxHeight: 120,
                        overflow: "auto",
                        listStyleType: "disc",
                      }}>
                      {data.rawMaterial.matchIndicator?.map((obj, index) => (
                        <>
                          <li key={index}>
                            {obj.label}
                            {obj.ComponentDeletionIndicator === "X" ? <MarkedForDeletion /> : ''}
                          </li>
                        </>
                      )) || "-"}
                    </ul>
                  )
                },
                {
                  key: "2",
                  label: <>
                    Missing ({data.rawMaterial.totalMissing})
                    {data.rawMaterial.missingIndicator?.map(obj => obj.ComponentDeletionIndicator).includes("X") ? <CautionFlag /> : null}
                  </>,
                  children: (
                    <ul
                      style={{
                        maxHeight: 120,
                        overflow: "auto",
                        listStyleType: "disc",
                      }}>
                      {data.rawMaterial.missingIndicator?.map((obj, index) => (
                        <li key={index}>
                          {obj.label}
                          {obj?.ComponentDeletionIndicator === "X" ? <MarkedForDeletion /> : ''}
                        </li>
                      )) || "-"}
                    </ul>
                  )
                },
                {
                  key: "3",
                  label: <>
                    Extra ({data.rawMaterial.totalExtra})
                    {data.rawMaterial.extraIndicator?.map(obj => obj.ComponentDeletionIndicator).includes("X") ? <CautionFlag /> : null}
                  </>,
                  children: (
                    <ul
                      style={{
                        maxHeight: 120,
                        overflow: "auto",
                        listStyleType: "disc",
                      }}>
                      {data.rawMaterial.extraIndicator?.map((obj, index) => (
                        <li key={index}>
                          {obj.label}
                          {obj.ComponentDeletionIndicator === "X" ? <MarkedForDeletion /> : ''}
                        </li>
                      )) || "-"}
                    </ul>
                  )
                },
              ]}
            />
          </Col>
        </Row>
        <Divider style={{ margin: "8px 0" }} />

        <Row>
          <Col span={12}>
            <Text strong>Pack. Materials</Text>
          </Col>
          <Col span={12}>
            <Text title="what percentage of the pack. materials in the BOM of the target SKU are present at this factory/sku.">
              {Math.round(
                (data.packagingMaterial.totalMatch / target.targetPMCount) * 100
              )}
              %
            </Text>
          </Col>
          <Col span={24}>
            <Collapse
              size="small"
              bordered={false}
              ghost
              activeKey={showCollpased.pm}
              onChange={(key) => {
                dispatch(updateCollapsed({ pm: key }));
              }}
              items={[
                {
                  key: "1",
                  label: <>
                    Match ({data.packagingMaterial.totalMatch})
                    {data.packagingMaterial.matchIndicator?.map(obj => obj.ComponentDeletionIndicator).includes("X") ? <CautionFlag /> : null}
                  </>,
                  children: (
                    <ul
                      style={{
                        maxHeight: 120,
                        overflow: "auto",
                        listStyleType: "disc",
                      }}>
                      {data.packagingMaterial.matchIndicator?.map((obj, index) => (
                        <li key={index}>
                          {obj.label}
                          {obj.ComponentDeletionIndicator === "X" ? <MarkedForDeletion /> : ''}
                        </li>
                      )) || "-"}
                    </ul>
                  )
                },
                {
                  key: "2",
                  label: <>
                    Missing ({data.packagingMaterial.totalMissing})
                    {data.packagingMaterial.missingIndicator?.map(obj => obj.ComponentDeletionIndicator).includes("X") ? <CautionFlag /> : null}
                  </>,
                  children: (
                    <ul
                      style={{
                        maxHeight: 120,
                        overflow: "auto",
                        listStyleType: "disc",
                      }}>
                      {data.packagingMaterial.missingIndicator?.map((obj, index) => (
                        <li key={index}>
                          {obj.label}
                          {obj.ComponentDeletionIndicator === "X" ? <MarkedForDeletion /> : ''}
                        </li>
                      )) || "-"}
                    </ul>
                  )
                },
                {
                  key: "3",
                  label: <>
                    Extra ({data.packagingMaterial.totalExtra})
                    {data.packagingMaterial.extraIndicator?.map(obj => obj.ComponentDeletionIndicator).includes("X") ? <CautionFlag /> : null}
                  </>,
                  children: (
                    <ul
                      style={{
                        maxHeight: 120,
                        overflow: "auto",
                        listStyleType: "disc",
                      }}>
                      {data.packagingMaterial.extraIndicator?.map((obj, index) => (
                        <li key={index}>
                          {obj.label}
                          {obj.ComponentDeletionIndicator === "X" ? <MarkedForDeletion /> : ''}
                        </li>
                      )) || "-"}
                    </ul>
                  )
                },
              ]}
            />
          </Col>
        </Row>
        <Divider style={{ margin: "8px 0" }} />

        <Row>
          <Col span={12}>
            <Text strong>Estimated Ex-Works</Text>
          </Col>
          <Col span={12}>
            <Text title="Per 1000 pieces">€{data?.cost}</Text>
          </Col>

          <Col span={24}>
            <Space direction="vertical" style={{ width: "100%" }}>
              <Row>
                <Col span={12} style={{ paddingLeft: 16 }}>
                  <Text>RM Cost</Text>
                  {data?.rmFlag === 1 ? (
                    <Tooltip placement="right" overlayInnerStyle={cautionCss} arrow={false} title="Caution: Some materials and/or Conversion costs are Unspecified, Zero(0) or Extremely Low" key="#f5d692">
                      <img
                        src={caution}
                        alt="caution"
                        style={{ marginBottom: 2, marginLeft: 4, height: 16 }}
                      />
                    </Tooltip>
                  ) : null}
                </Col>
                <Col span={12}>
                  <Text title="Per 1000 pieces">€{data?.rmCost}</Text>
                </Col>
              </Row>
              <Row>
                <Col span={12} style={{ paddingLeft: 16 }}>
                  <Text>PM Cost</Text>
                  {data?.pmFlag === 1 ? (
                    <Tooltip placement="right" overlayInnerStyle={cautionCss} arrow={false} title="Caution: Some materials and/or Conversion costs are Unspecified, Zero(0) or Extremely low" key="#f5d692">
                      <img
                        src={caution}
                        alt="caution"
                        style={{ marginBottom: 2, marginLeft: 4, height: 16 }}
                      />
                    </Tooltip>
                  ) : null}
                </Col>
                <Col span={12}>
                  <Text title="Per 1000 pieces">€{data?.pmCost}</Text>
                </Col>
              </Row>
              <Row>
                <Col span={12} style={{ paddingLeft: 16 }}>
                  <Text>Conversion Cost</Text>
                  {data?.ccFlag === 1 ? (
                    <Tooltip placement="right" overlayInnerStyle={cautionCss} arrow={false} title="Caution: Some materials and/or Conversion costs are Unspecified, Zero(0) or Extremely low" key="#f5d692">
                      <img
                        src={caution}
                        alt="caution"
                        style={{ marginBottom: 2, marginLeft: 4, height: 16 }}
                      />
                    </Tooltip>
                  ) : null}
                </Col>
                <Col span={12}>
                  <Text title="Per 1000 pieces">€{data?.conversionCost}</Text>
                </Col>
              </Row>
            </Space>
          </Col>
        </Row>
        <Divider style={{ margin: "8px 0" }} />

        {isRegionalView ? (
          <>
            <Row>
              <Col span={12}>
                <Text strong>Transportation Cost</Text>
              </Col>
              <Col span={12}>
                <Text title="Data Not Available">NA</Text>
              </Col>

              <Col span={24}>
                <Space direction="vertical" style={{ width: "100%" }}>
                  <Row>
                    <Col span={12} style={{ paddingLeft: 16 }}>
                      <Text>Taxes And Duties</Text>
                    </Col>
                    <Col span={12}>
                      <Text title="Data Not Available">NA</Text>
                    </Col>
                  </Row>
                  <Row align="middle">
                    <Col span={12} style={{ paddingLeft: 16 }}>
                      <Text>Transportation Cost With Temperature Control</Text>
                    </Col>
                    <Col span={12}>
                      <Text title="Data Not Available">NA</Text>
                    </Col>
                  </Row>
                  <Row align="middle">
                    <Col span={12} style={{ paddingLeft: 16 }}>
                      <Text>
                        Transportation Cost Without Temperature Control
                      </Text>
                    </Col>
                    <Col span={12}>
                      <Text title="Data Not Available">NA</Text>
                    </Col>
                  </Row>
                </Space>
              </Col>
            </Row>
            <Divider style={{ margin: "8px 0" }} />
          </>
        ) : null}

        <Row>
          <Col span={24}>
            <Collapse
              size="small"
              id="cu"
              bordered={false}
              ghost
              activeKey={showCollpased.capacityUtilization}
              onChange={(key) => {
                dispatch(updateCollapsed({ capacityUtilization: key }));
              }}
              items={[
                {
                  key: "1",
                  label: (
                    <Row>
                      <Col span={12}>
                        <Text strong>Capacity Utilization</Text>
                      </Col>
                      <Col span={12}>
                        <Text>{data.capacity}%</Text>
                      </Col>
                    </Row>
                  ),
                  children: data?.capacityCategory?.map((obj, index) => (
                    <Collapse
                      key={index}
                      size="small"
                      bordered={false}
                      ghost
                      items={[
                        {
                          key: "1",
                          label: (
                            <Row>
                              <Col span={12}>
                                <Text strong>{obj.category}</Text>
                              </Col>
                              <Col span={12}>
                                <Text>{obj.percetage}%</Text>
                              </Col>
                            </Row>
                          ),
                          children: (
                            <Table
                              size="small"
                              bordered={false}
                              pagination={false}
                              scroll={{ y: 120 }}
                              dataSource={obj.categoryTable}
                              columns={categoryUtilizationColumns}
                            />
                          ),
                        },
                      ]}
                    />
                  )),
                },
              ]}
            />
          </Col>
        </Row>
      </div>
    </Card>
  );
}

export default SUDetailCard;
